import styled from "@emotion/styled";

import { theme } from "../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const PagerSegment = styled.span({
    display: "inline-block",
    marginLeft: 30,
});

export const ErrorContainer = styled.span(props => ({
    color: theme(props).semanticColors.danger.color,
    paddingLeft: 10,
}));

export const TextContainer = styled.span({
    paddingRight: 10,
});
